import axios from 'axios';

class ValidatorApi {
  constructor() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.rules = opts.rules || [];
    this.rulesEndpoint = opts.rulesEndpoint || null;
    this.axios = opts.axios || axios.create({
      baseURL: opts.baseURL || undefined
    });
    this.rulesCallback = opts.rulesCallback || (() => {});
    // We don't want to fire off every promise as soon as it comes in.
    // we should wait to see if synchronous error exist first. Put them in a queue.
    this.asyncQueue = [];
    if (!this.rules.length && this.rulesEndpoint) {
      this.updateRules();
    }
  }
  fetchRules(apiEndpoint) {
    return this.axios.get(apiEndpoint).then(response => {
      return response.data;
    });
  }
  async updateRules() {
    let endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    const apiEndpoint = endpoint || this.rulesEndpoint;
    if (!apiEndpoint) {
      return;
    }
    try {
      this.rules = await this.fetchRules(apiEndpoint);
      this.rulesCallback(this.rules);
    } catch (error) {
      throw new Error(`Could not retrieve rules or rulesCallback threw an Error.\n${error.message}`);
    }
  }
  queueAsyncRequest(rule, value) {
    const uri = rule.data.replace('{0}', value);
    const callback = res => ({
      passed: res.data.isValid,
      rule
    });
    this.asyncQueue.push({
      uri,
      rule,
      callback
    });
  }
  async validate(fieldName, payload) {
    if (!fieldName || !payload) return '';
    const {
      rules
    } = this;
    const fieldValidations = rules.filter(i => i.property === fieldName);
    if (fieldValidations === null || fieldValidations.length === 0) return '';
    const value = payload[fieldName];

    // Run synchronous validations first.
    const errors = fieldValidations.filter(rule => !this.validateByRule(rule, value)).map(rule => rule.message);
    if (errors.length) {
      return errors[0];
    }

    // process asyncQueue.
    while (this.asyncQueue.length) {
      const {
        uri,
        callback
      } = this.asyncQueue.shift();
      // We need to put await inside the loop to avoid side effects for subsequent calls to `validate()`
      // eslint-disable-next-line no-await-in-loop
      const result = await this.axios.get(uri).then(callback);
      if (!result.passed) {
        return new Promise(resolve => resolve(result.rule.message));
      }
    }
    return '';
  }
  validateByRule(rule, value) {
    if (rule.type === 'Required') {
      return !(value === null || value === undefined || value === '');
    }

    // after required, only check non-empty values
    if (!value) {
      return true;
    }
    switch (rule.type) {
      case 'MaxLength':
        return value.toString().length <= parseInt(rule.data, 10);
      case 'MinLength':
        return value.toString().length >= parseInt(rule.data, 10);
      case 'Range':
        {
          const limits = rule.data.split('-');
          return value.toString().length >= parseInt(limits[0], 10) && value.toString().length <= parseInt(limits[1], 10);
        }
      case 'RegularExpression':
        if (Array.isArray(rule.data)) {
          const [pattern, flags] = rule.data;
          return new RegExp(pattern, flags).test(value);
        }
        return new RegExp(rule.data).test(value);
      case 'ApiValidation':
        {
          this.queueAsyncRequest(rule, value);
          return true;
        }
      default:
        // eslint-disable-next-line no-console
        console.warn(`Unsupported validation type ${rule.type}`);
        break;
    }
    return true;
  }
}

export { ValidatorApi as default };
//# sourceMappingURL=index.esm.js.map
